<div class="devstroupe-vertical-navigation-wrapper">
    <!-- Header -->
    <div class="devstroupe-vertical-navigation-header">
        <ng-content select="[devstroupeVerticalNavigationHeader]"></ng-content>
    </div>

    <!-- Content -->
    <div
        class="devstroupe-vertical-navigation-content"
        devstroupeScrollbar
        [devstroupeScrollbarOptions]="{ wheelPropagation: inner, suppressScrollX: true }"
        #navigationContent
    >
        <!-- Content header -->
        <div class="devstroupe-vertical-navigation-content-header">
            <ng-content select="[devstroupeVerticalNavigationContentHeader]"></ng-content>
        </div>
        <ng-content select="[devstroupeVerticalNavigationContentBody]"></ng-content>

        <!-- Items -->
        <ng-container *ngFor="let item of navigation; trackBy: trackByFn">
            <!-- Skip the hidden items -->
            <ng-container *ngIf="(item.hidden && !item.hidden(this.verificacao)) || !item.hidden">
                <!-- Aside -->
                <ng-container *ngIf="item.type === 'aside'">
                    <devstroupe-vertical-navigation-aside-item
                        [item]="item"
                        [name]="name"
                        [activeItemId]="activeAsideItemId"
                        [autoCollapse]="autoCollapse"
                        [skipChildren]="true"
                        (click)="toggleAside(item)"
                    ></devstroupe-vertical-navigation-aside-item>
                </ng-container>

                <!-- Basic -->
                <ng-container *ngIf="item.type === 'basic'">
                    <devstroupe-vertical-navigation-basic-item [item]="item" [name]="name"></devstroupe-vertical-navigation-basic-item>
                </ng-container>

                <!-- Collapsable -->
                <ng-container *ngIf="item.type === 'collapsable'">
                    <devstroupe-vertical-navigation-collapsable-item
                        [item]="item"
                        [name]="name"
                        [autoCollapse]="autoCollapse"
                    ></devstroupe-vertical-navigation-collapsable-item>
                </ng-container>

                <!-- Divider -->
                <ng-container *ngIf="item.type === 'divider'">
                    <devstroupe-vertical-navigation-divider-item [item]="item" [name]="name"></devstroupe-vertical-navigation-divider-item>
                </ng-container>

                <!-- Group -->
                <ng-container *ngIf="item.type === 'group'">
                    <devstroupe-vertical-navigation-group-item
                        [item]="item"
                        [name]="name"
                        [autoCollapse]="autoCollapse"
                    ></devstroupe-vertical-navigation-group-item>
                </ng-container>

                <!-- Spacer -->
                <ng-container *ngIf="item.type === 'spacer'">
                    <devstroupe-vertical-navigation-spacer-item [item]="item" [name]="name"></devstroupe-vertical-navigation-spacer-item>
                </ng-container>
            </ng-container>
        </ng-container>

        <!-- Content footer -->
        <div class="devstroupe-vertical-navigation-content-footer">
            <ng-content select="[devstroupeVerticalNavigationContentFooter]"></ng-content>
        </div>
    </div>

    <!-- Footer -->
    <div class="devstroupe-vertical-navigation-footer">
        <ng-content select="[devstroupeVerticalNavigationFooter]"> </ng-content>
    </div>
</div>

<!-- Aside -->
<ng-container *ngIf="activeAsideItemId">
    <div
        class="devstroupe-vertical-navigation-aside-wrapper"
        devstroupeScrollbar
        [devstroupeScrollbarOptions]="{ wheelPropagation: false, suppressScrollX: true }"
        [@fadeInLeft]="position === 'left'"
        [@fadeInRight]="position === 'right'"
        [@fadeOutLeft]="position === 'left'"
        [@fadeOutRight]="position === 'right'"
    >
        <!-- Items -->
        <ng-container *ngFor="let item of navigation; trackBy: trackByFn">
            <!-- Skip the hidden items -->
            <ng-container *ngIf="(item.hidden && !item.hidden(this.verificacao)) || !item.hidden">
                <!-- Aside -->
                <ng-container *ngIf="item.type === 'aside' && item.id === activeAsideItemId">
                    <devstroupe-vertical-navigation-aside-item
                        [item]="item"
                        [name]="name"
                        [autoCollapse]="autoCollapse"
                    ></devstroupe-vertical-navigation-aside-item>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
</ng-container>
